import { boolean, object } from "yup";
import { optionalEmail } from "../../../acd/util.js";
import { dateAndTimeWithin24HoursValidation, defaultAddress, defaultContextFields, generateDateBeforeNowValidationRule, hospital, nameAndAddress, } from "../../../shared.js";
export const a10UploadablePart1DataSchema = object({
    ...defaultContextFields({ section12Required: false }),
    hospital: hospital,
    emailAddressOfSignee: optionalEmail,
    nameAndAddressOfSignee: nameAndAddress({
        nameRequiredError: "Please enter name of signee",
        addressRequiredError: "Please enter address of signee",
    }, true).default(defaultAddress),
    lastSeenDateTime: generateDateBeforeNowValidationRule("date-time", "You cannot enter a date and/or time in the future.")
        .concat(dateAndTimeWithin24HoursValidation())
        .required("Please enter date and time signee last saw the patient on"),
    medicalPractitionersPreviousAcquaintance: boolean()
        .default(null)
        .required("Please confirm if the medical practitioner have previous acquaintance with the patient before making their recommendation"),
    signatureDate: generateDateBeforeNowValidationRule("date-time", "You cannot enter a date and/or time in the future.").required("Please enter signature date "),
});
export const exampleA10UploadableData = [
    {
        data: {
            nameAndAddressOfSignee: {
                name: "name",
                address: "Address",
                isConfirmed: true,
                postalCode: "ABC 123",
            },
            hospital: {
                name: "Hospital",
                address: "Hospital Address",
                postalCode: "ABC 123",
                isConfirmed: true,
            },
            emailAddressOfSignee: "stuart@thalamos.co.uk",
            lastSeenDateTime: "2021-01-01T15:00:00",
            medicalPractitionersPreviousAcquaintance: false,
            signatureDate: "2021-01-01",
            user: {
                name: "Dr. Sarah Glass",
                address: "143 Fake Street",
                postalCode: "AB1 2CD",
                email: "sarah.glass@houses.com",
                isConfirmed: true,
                isSection12Approved: true,
                isGuest: false,
            },
            patient: {
                name: "Bob Smith",
                address: "123 Fake Street",
                postalCode: "AB1 2CD",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
        },
    },
];
//# sourceMappingURL=a10.js.map